var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 100,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H187V187H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.92 89.9688L57.0527 90.706L76.8722 91.812L77.92 89.9688Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4265 94.3538L54.5107 95.091L74.3982 96.197L75.4265 94.3538Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9335 98.7677L52.0371 99.505L71.9051 100.611L72.9335 98.7677Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.489 103.172L49.5732 103.919L69.4122 105.015L70.489 103.172Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0516 67.8307L69.4219 68.7814L96.1292 70.2657L96.0516 67.8307Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.886 63.4749L71.9629 64.3189L95.9636 65.6964L95.886 63.4749Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7119 59.2839L74.3984 59.9824L95.8186 61.1757L95.7119 59.2839Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5761 54.9669L76.8916 55.5975L95.644 56.7034L95.5761 54.9669Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4497 51.4841H79.2002L95.4788 52.3475L95.4497 51.4841Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9669 107.567L47.0996 108.323H67.54L67.9669 107.567Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.679 51.6296H108.605L107.751 53.143L122.798 53.9385C122.972 53.9385 122.972 54.1908 122.72 54.1908L106.868 54.7243L105.336 57.4018L120.285 58.2847C120.489 58.3138 120.44 58.5854 120.256 58.5854L104.385 59.1092L102.901 61.6704L117.821 62.495C118.151 62.5241 118.151 62.7957 117.821 62.7957L101.969 63.3487L100.466 66.0262L115.338 66.8799C115.667 66.909 115.638 67.2097 115.338 67.2097L99.4858 67.7724L97.953 70.4208L112.854 71.2454C113.077 71.2745 113.106 71.5462 112.806 71.5462L67.1323 73.079L110.468 75.4848C110.739 75.4848 110.72 75.8341 110.419 75.8341L64.6779 77.4639L108.013 79.8698C108.217 79.8698 108.265 80.1996 107.965 80.1996L62.1459 81.8585L105.481 84.2644C105.656 84.2935 105.83 84.6137 105.452 84.6428L59.7109 86.2726L103.046 88.6785C103.172 88.7076 103.298 89.0277 102.998 89.0277L79.9767 89.8523L80.0543 91.9284L100.572 93.0634C100.728 93.0925 100.795 93.3932 100.524 93.3932L80.1319 94.1208L80.2289 96.4394L98.0403 97.4289C98.2149 97.458 98.2925 97.8073 97.9918 97.8073L80.3357 98.4281L80.4133 100.98L95.5859 101.824C95.7605 101.853 95.809 102.173 95.5083 102.173L80.4812 102.706L80.5782 105.51L93.1218 106.208C93.2964 106.238 93.2964 106.538 93.0442 106.538L80.6267 106.985L80.6752 108.188H121.158C131.888 108.188 141.521 100.359 143.325 94.1402C145.13 87.9218 145.13 82.3048 136.506 79.4914C141.317 78.3855 149.699 72.9528 151.348 65.4441C152.852 58.6242 150.349 51.649 138.659 51.6296H138.679ZM118.316 95.188H105.879L112.903 82.751H122.128C131.655 82.751 127.047 95.188 118.316 95.188ZM134.42 68.5C134.022 70.0037 131.005 73.8162 127.192 73.8162H117.967L123.884 63.3875H128.599C134.614 63.5912 134.817 66.9963 134.42 68.5Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.245 126.212C184.245 121.391 180.238 117.355 175.417 117.355C170.595 117.355 166.434 121.459 166.434 126.494C166.434 131.529 170.44 135.506 175.446 135.506C179.103 135.506 182.586 133.003 183.614 129.588H179.045C178.133 131.024 176.95 131.684 175.32 131.684C173.254 131.684 171.41 130.277 170.809 128.269H184.022C184.177 127.299 184.245 126.833 184.245 126.203V126.212ZM170.692 125.009C171.284 122.662 173.166 121.158 175.485 121.158C177.803 121.158 179.617 122.633 180.18 125.009H170.692Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.913 118.189V119.596C123.603 118.189 121.692 117.384 119.664 117.384C115.153 117.384 111.312 121.236 111.312 126.241C111.312 130.966 114.707 135.205 119.752 135.205C121.973 135.205 123.661 134.691 125.262 132.877V135.099H129.084V118.189H124.922H124.913ZM120.246 131.626C117.346 131.626 114.998 129.278 114.998 126.377C114.998 123.477 117.346 121.129 120.246 121.129C123.147 121.129 125.495 123.477 125.495 126.377C125.495 129.278 123.147 131.626 120.246 131.626Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0785 117.355C9.36139 117.355 8.04203 117.947 6.60625 119.422V117.763H2.75488V135.099H6.91669V126.93C6.91669 124.709 7.10101 121.168 10.1763 121.168C13.0575 121.168 13.368 124.486 13.368 126.61V135.089H17.5298V125.795C17.5298 123.35 17.3455 122.196 16.6858 120.818C15.7157 118.752 13.4262 117.345 11.0785 117.345V117.355Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9422 126.212C36.9422 121.391 32.9356 117.355 28.1142 117.355C23.2927 117.355 19.1309 121.459 19.1309 126.494C19.1309 131.529 23.1374 135.506 28.1433 135.506C31.8103 135.506 35.2833 133.003 36.3117 129.588H31.7424C30.8305 131.024 29.6469 131.684 28.0171 131.684C25.9508 131.684 24.1076 130.277 23.5061 128.269H36.7191C36.8743 127.299 36.9422 126.833 36.9422 126.203V126.212ZM23.3897 125.009C23.9815 122.662 25.8635 121.158 28.1821 121.158C30.5006 121.158 32.3148 122.633 32.8774 125.009H23.3897Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.442 135.089H109.604V111.952H105.442V135.089Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.056 117.355C138.339 117.355 137.02 117.947 135.584 119.422V117.763H131.732V135.099H135.894V126.93C135.894 124.709 136.079 121.168 139.154 121.168C142.035 121.168 142.346 124.486 142.346 126.61V135.089H146.507V125.795C146.507 123.35 146.323 122.196 145.663 120.818C144.693 118.752 142.404 117.345 140.056 117.345V117.355Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.897 121.168C158.808 121.168 159.905 121.798 160.933 123.545H165.628C164.348 119.819 161.059 117.345 157.053 117.345C151.979 117.345 147.914 121.381 147.914 126.358C147.914 131.335 152.018 135.496 157.053 135.496C159.623 135.496 162.155 134.371 163.873 132.46C164.746 131.49 165.066 130.927 165.628 129.394H160.933C159.963 130.898 158.711 131.684 157.15 131.684C154.239 131.684 152.076 129.433 152.076 126.426C152.076 123.418 154.142 121.168 156.897 121.168Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8525 128.337L49.9033 117.763H46.5564L43.5782 128.337L40.0566 117.763H36.3799L42.1715 135.099H44.8393L48.2153 123.865L51.504 135.099H54.298L59.8567 117.763H56.4128L52.8525 128.337Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1553 117.375C73.118 117.375 71.2166 118.18 69.9069 119.586V111.961H65.7451V135.089H69.5674V132.867C71.1681 134.681 72.8561 135.196 75.0777 135.196C80.1126 135.196 83.5177 130.956 83.5177 126.232C83.5177 121.226 79.676 117.375 75.165 117.375H75.1553ZM74.5732 131.626C71.6725 131.626 69.3249 129.278 69.3249 126.377C69.3249 123.477 71.6725 121.129 74.5732 121.129C77.4739 121.129 79.8215 123.477 79.8215 126.377C79.8215 129.278 77.4739 131.626 74.5732 131.626Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4966 118.189V119.596C97.1772 118.189 95.2758 117.384 93.2482 117.384C88.7372 117.384 84.8955 121.236 84.8955 126.241C84.8955 130.966 88.2909 135.205 93.3355 135.205C95.5571 135.205 97.2451 134.691 98.8458 132.877V135.099H102.668V118.189H98.5063H98.4966ZM93.8303 131.626C90.9296 131.626 88.582 129.278 88.582 126.377C88.582 123.477 90.9296 121.129 93.8303 121.129C96.731 121.129 99.0786 123.477 99.0786 126.377C99.0786 129.278 96.731 131.626 93.8303 131.626Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBalance);
export default __webpack_public_path__ + "static/media/NewBalance.74b936bc7ff18e8f61fdafad5239df3b.svg";
export { ForwardRef as ReactComponent };